import { ANALYTICS_EVENTS } from "../../../analytics/events";
import { posthog } from "../../../analytics/analyticsClient";
import { prefersReducedMotion } from "./useProductDemo";

export const WAITLIST_SECTION_ID = "waitlist";

export type WaitlistCtaPlacement =
  | "nav"
  | "hero"
  | "final"
  | "decision_grid"
  | "pricing";

export function scrollToWaitlistSection() {
  const node = document.getElementById(WAITLIST_SECTION_ID);
  if (!node) return;
  node.scrollIntoView({
    behavior: prefersReducedMotion() ? "auto" : "smooth",
    block: "start",
  });
}

export function trackWaitlistCta(placement: WaitlistCtaPlacement) {
  posthog.capture(ANALYTICS_EVENTS.HERO_CTA_CLICKED, { placement });
}

export function joinWaitlistFromClick(
  placement: WaitlistCtaPlacement,
  event?: { preventDefault: () => void },
) {
  event?.preventDefault();
  trackWaitlistCta(placement);
  scrollToWaitlistSection();
}
